// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"41052d90","90":"78ec1287","165":"e9362500","250":"2c2d1f11","355":"db773981","641":"1acce3e4","705":"9a08ae56","756":"25be7b56","918":"824c10d6"}[chunkId] + ".chunk.js";
};